//import Compressor from 'compressorjs';
//import { $EventBus } from '@/main';
import { mapActions, mapState } from 'vuex';
import SubTypeSelect from '@/components/incidents/elements/SubTypeSelect/SubTypeSelect.vue';
import { $EventBus } from '@/main';

export default {
	name: 'AreaSelect',
	props: {
		value: {
			type: Array,
			required: false,
		},
		label: {
			type: String,
			required: false,
		},
	},
	data() {
		return {
			loadingArea: false,
			selectedArea: null,
			selectedClasification: null,
			requireRule: [(v) => !!v || 'Campo requerido'],
		};
	},
	created() {
		this.getAreas();
	},

	watch: {
		allAreas(newVal) {
			if (newVal.length === 1) {
				this.selectedArea = newVal[0];
				this.changeArea(); 
			}
		},
	},

	mounted() { },
	computed: {
		...mapState('area', ['allAreas']),

		// evidences: {
		// 	get() {
		// 		return this.value || false;
		// 	},
		// 	set(value) {
		// 		this.$emit('input', value);
		// 	},
		// },
		buttonText() {
			return this.label || this.defaultButtonText;
		},
	},
	methods: {
		...mapActions('area', ['listAllAreas']),
		...mapActions('subtype', ['switchFlagObserveAsset', 'changeSelectedClassification']),

		async getAreas() {
			this.loadingArea = true;
		
			try {
				const { ok } = await this.listAllAreas({ onTree: true });
		
				if (!ok) {
					$EventBus.$emit('showSnack', 'error', 'No se pudo cargar las áreas');
				}
			} catch (error) {
				$EventBus.$emit('showSnack', 'error', 'No se pudo cargar las áreas');
			} finally {
				this.loadingArea = false;
			}
		},

		getClasification(area) {
			const classifications = area?.classifications;
			return Array.isArray(classifications) ? classifications : [];
		},

		getSubTypes(clasification) {
			const subTypes = clasification?.subtypes;
			return Array.isArray(subTypes) ? subTypes : [];
		},

		changeArea() {
			this.selectedClasification = null;
			this.changeSelectedClassification(null);
			this.switchFlagObserveAsset(false);
		},

		selectClassification() {
			this.changeSelectedClassification(this.selectedClasification);
		}
	},
	components: { SubTypeSelect },
};
